import { FmImageCardActionsProps } from "domains/file-manager/components/FileManagerImage/Card/Actions";
import MenuItem from "domains/ui/components/Menu/MenuItem";

export type CardActions3DCustomProps = {
  _never?: never;
};

export type CardActions3DProps =
  FmImageCardActionsProps<CardActions3DCustomProps>;

export default function CardActions3D({
  asset,
  top,
  bottom,
}: CardActions3DProps) {
  const modelId = asset?.metadata.modelId;

  if (!modelId) {
    return null;
  }

  return (
    <>
      {top}

      {modelId && (
        <MenuItem
          w="170px"
          iconId="Nav/Model/Outline"
          iconH="12px"
          internalLink={{
            pathname: "/3d/new",
            query: {
              modelId,
            },
          }}
          text="Model"
        />
      )}

      {bottom}
    </>
  );
}
